<template>
    <div class="editProfile mainContent">
        <div class="frameMobile">
            <PersonalInfo />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import PersonalInfo from '../../components/Settings/PersonalInfo';
    import HomeAddress from '../../components/Settings/AddressBook';

    export default {
        computed : {
            ...mapGetters(["getUserData"]),
        },
        components: {
            PersonalInfo
        }
    }
</script>